const HEADER_LEFT = 'headerLeft';
const HEADER_RIGHT = 'headerRight';
const HERO = 'hero';
const BOTTOM = 'bottom';
const MIDDLE = 'middle';
const TOP = 'top';
const CENTER_RIGHT = 'centerRight';
const PRODUCTS_LEFT = 'productsLeft';
const PRODUCTS_RIGHT = 'productsRight';
const PRODUCTS_CENTER = 'productsCenter';

export {
  HEADER_LEFT,
  HEADER_RIGHT,
  HERO,
  BOTTOM,
  TOP,
  MIDDLE,
  CENTER_RIGHT,
  PRODUCTS_LEFT,
  PRODUCTS_RIGHT,
  PRODUCTS_CENTER,
};
